export default "__VITE_PUBLIC_ASSET__1f009735__"